import styled from 'styled-components';
import { StyledDescription } from 'components/boxes/DescriptionBox/StyledDescriptionBox';
import { Colors, Breakpoints } from 'styles/Constants';
import BaseBox from 'components/boxes/BaseBox';

export const CampaignCardWrapper = styled.div`
  padding: 20px;

  ${StyledDescription} {
    padding: 0 25px 0 0;
  }

  button {
    width: 90%;
  }

  p {
    font-weight: 500;
    line-height: 1.5;
    font-size: 14px;

    &.purple-text {
      color: #b721ff;
    }
  }
`;

export const NetworksCard = styled.div`
  align-items: center;
  display: flex;
  margin: 15px 0;

  > * {
    margin-right: 10px;
  }
`;

export const DivIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 25px;
    margin: 5px;
  }
`;

export const GridWrapper = styled.div`
  ${BaseBox};

  display: grid;
  grid-template-columns: 200px 10fr 2fr;
  gap: 20px;
  align-items: center;
  background: ${Colors.normalWhite};
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 15px;
  box-shadow: 0 1px 6px 0 rgb(79 79 79 / 38%);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px 0 rgb(79 79 79 / 25%);
  }

  .content-img {
    width: 150px;
    height: 150px;
    min-height: inherit !important;
    display: flex !important;
    align-items: center !important;
  }

  img {
    width: 100%;
    height: inherit;
    object-fit: contain;
  }

  .time-line {
    margin: 0 0 5px 0;
    font-weight: 500;
    line-height: 1.5;
    font-size: 14px;
    color: ${Colors.primaryNormalPurple};
    text-transform: capitalize;
  }

  .social-networks {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .format {
    margin-left: 15px;
  }

  .subtitle {
    margin-right: 5px;
    font-weight: bold;
  }

  @media only screen and (max-width: 900px) {
    width: 120%;
  }

  @media (max-width: ${Breakpoints.medium}) {
    display: none;
  }
`;

export const MarginText = styled.div`
  padding: 5px;
  font-weight: 500;
  font-size: 14px;
  overflow: hidden;

  &.m-auto {
    margin: auto 0px;
  }

  div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    h2 {
      font-weight: bold;
      position: relative;
      font-size: 18px;
      margin: 0;
    }
  }

  @media (max-width: ${Breakpoints.medium}) {
    &.m-auto {
      .time-line {
        font-size: 11px;
      }

      h2 {
        font-size: 16px;
      }
    }
  }
`;

// ===== NUEVOS ESTILOS RESPONSIVE PARA MOBILE =====

export const MobileCampaignCard = styled.div`
  display: none;

  @media (max-width: ${Breakpoints.medium}) {
    display: block;
    background: ${Colors.normalWhite};
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 1px 6px 0 rgba(79, 79, 79, 0.38);
    transition: all 0.5s ease-out 0s;
    position: relative;
    z-index: 2;
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
`;

export const MobileCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;

  .mobile-image {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .mobile-header-content {
    flex: 1;

    .mobile-time-line {
      font-size: 12px;
      color: ${Colors.primaryNormalPurple};
      margin: 0 0 6px 0;
      font-weight: 500;
      text-transform: capitalize;
    }

    .mobile-title {
      font-size: 16px;
      font-weight: 600;
      color: ${Colors.primaryText};
      margin: 0;
      line-height: 1.3;
    }
  }

  .mobile-tag {
    position: absolute;
    top: 12px;
    right: 12px;
  }

  .mobile-social-networks {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;
    padding: 8px 0;
  }
`;

export const MobileCardContent = styled.div`
  .mobile-actions {
    display: flex;
    justify-content: center;

    button {
      width: 100%;
      justify-content: center;
    }
  }
`;
